import React, { useEffect } from 'react';
import Text from '../../../Text';
import Box from '../../../Box';
import { st, classes } from './Subheader.st.css';
import { isString } from '../../../utils/StringUtils';
import deprecationLog from '../../../utils/deprecationLog';
import { SubheaderProps } from './Subheader.types';

/**
 * @deprecated Card.Subheader is deprecated and will be removed in the next major version. Please use SectionHeader instead.
 */
export const Subheader = ({
  dataHook,
  title,
  suffix,
  skin = 'standard',
}: SubheaderProps) => {
  useEffect(() => {
    deprecationLog(
      'Card.Subheader is deprecated and will be removed in the next major version. Please use SectionHeader instead.',
    );
  }, []);

  return (
    <div
      data-hook={dataHook}
      className={st(classes.root, {
        skin,
      })}
    >
      <Box verticalAlign="middle" flexGrow={1} overflow="hidden">
        {isString(title) ? (
          <Text ellipsis weight="normal" size="medium" dataHook="title">
            {title}
          </Text>
        ) : (
          <div data-hook="title-node">{title}</div>
        )}
      </Box>

      {suffix && (
        <div className={classes.suffix} data-hook="suffix-node">
          {suffix}
        </div>
      )}
    </div>
  );
};

Subheader.displayName = 'Card.Subheader';

export default Subheader;
